<script setup>

defineProps({
  id: {
    type: Number,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  details: {
    type: String,
    required: true
  },
  isCompleted: {
    type: Boolean,
    default: false
  },
  isActive: {
    type: Boolean,
    default: false
  },
  stepLabelNextLine: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['onChangeClicked'])

</script>

<template>
  <div :class="{
    'page-sales-funnel__step': true,
    'completed': isCompleted,
    'active': isActive,
    'next-line-label': stepLabelNextLine
  }">
    <div class="step__header">
      <div class="step__inner">
        <span class="step__number">{{ id }}</span>
        <div class="step__details">
          {{ details }}
          <span class="step__name">{{ name }}</span>
        </div>
      </div>

      <a @click="emits('onChangeClicked')" class="step__link">{{ $t('Change') }}</a>
    </div>

    <span v-if="isCompleted && stepLabelNextLine" class="step__completedHeaderContent">
      <slot name="completedHeaderContent" />
    </span>

    <div class="step__content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.completed.next-line-label {
  .step__header {
    padding: 2.4rem 0 0;
  }
}

.step__number {
  font-weight: 500;
}
</style>